import { useCallback, useDebugValue } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { fetchUsers as fetchUsersThunk, usersSelectors } from './users.state';
import { User } from './users.types';
import { AppDispatch } from '../../index';

export const useUsersState = (): RootState['users'] => {
  const users = useSelector<RootState, RootState['users']>(state => state.users);

  useDebugValue(users);

  return users;
};

export const useUsersValues = (): User[] => {
  const users = useSelector<RootState, RootState['users']>(state => state.users);

  const result = usersSelectors.selectAll(users);

  useDebugValue(result);

  return result;
};

export const useUserById = (id: number): User | null => {
  const users = useSelector<RootState, RootState['users']>(state => state.users);

  const result = usersSelectors.selectById(users, id) || null;

  useDebugValue(result);

  return result;
};

export type UseUsers = () => [{ isPending: boolean; users: User[] }, () => void];

export const useUsers: UseUsers = () => {
  const dispatch: AppDispatch = useDispatch();
  const { isPending } = useUsersState();
  const users = useUsersValues();

  const fetchUsers = useCallback(() => {
    dispatch(fetchUsersThunk({}));
  }, [dispatch]);

  return [{ users, isPending }, fetchUsers];
};
